'use client';

import { useEffect } from 'react';

export default function PWAManifest() {
    useEffect(() => {
        // Adicionar link do manifest se não existir
        if (typeof document !== 'undefined') {
            const existingLink = document.querySelector('link[rel="manifest"]');
            if (!existingLink) {
                const link = document.createElement('link');
                link.rel = 'manifest';
                link.href = '/manifest.json';
                document.head.appendChild(link);
            }
        }
    }, []);

    return null;
}

